import React from "react";
import { string, number, object, func, oneOfType, bool } from "prop-types";
import { Row, Col } from "react-bootstrap";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import TestBatteryInfoCards from "./TestBatteryInfoCards";

const ScreenReaderCompatibility = ({
  fromScheduleExistingCandidates,
  handleChangeScreenReaderCompatibility,
  job,
  jobDetailId,
  screenReaderCompatibilityEnabled,
  testBatteryId,
  testBatterySubTests,
  timeFactor,
}) => (
  <Row className="mt-3">
    <Col>
      <h4 className="mb-3">Screen Reader Compatibility</h4>
      <p>
        A screen reader compatible version, which omits image-based questions,
        can be offered to candidates for selected tests associated with this
        job:
      </p>
      <TestBatteryInfoCards
        testBatterySubTests={testBatterySubTests}
        job={job}
        testBatteryId={testBatteryId}
        jobDetailId={jobDetailId}
        timeFactor={Number(timeFactor)}
        fromScheduleExistingCandidates={fromScheduleExistingCandidates}
        filterBy="screenReaderCompatibility"
        assessmentSettings={
          fromScheduleExistingCandidates
            ? job && job.get("assessmentSettings")
            : job && job.getIn([jobDetailId, "assessmentSettings"])
        }
      />
      <div className="advancedSettingsGrayInputRow">
        <strong style={{ fontSize: "14px" }}>
          Screen Reader Compatible Version
        </strong>
        <Toggle
          id="screenReaderCompatibilityToggle"
          icons={false}
          checked={screenReaderCompatibilityEnabled}
          onChange={handleChangeScreenReaderCompatibility}
        />
      </div>
      <p className="text-gray-70">
        Consider whether it is also appropriate to add a time adjustment if you
        are making screen reader compatibility adjustments.
      </p>
    </Col>
  </Row>
);

ScreenReaderCompatibility.propTypes = {
  fromScheduleExistingCandidates: bool,
  handleChangeScreenReaderCompatibility: func,
  job: object,
  jobDetailId: string,
  screenReaderCompatibilityEnabled: bool,
  testBatteryId: number,
  testBatterySubTests: object,
  timeFactor: oneOfType([number, string]),
};

export default ScreenReaderCompatibility;
